"use client";

import { useEffect } from "react";

export default function AdsenseAd() {
  useEffect(() => {
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-6855691641655295"
      data-ad-slot="9872681587"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
